import template from './labor-category-dropdown.html';
import controller from './labor-category-dropdown.controller';

let laborCategoryDropdownComponent = {
  restrict: 'E',
  bindings: {
    selectedLaborCategory: '=ngModel',
    onSelect: '&?',
    required: '<?',
    placeholder: '@?',
    disabled: '<?',
    contractId: '@?',
    laborCategories: '<?' // Optional: pass labor categories directly instead of fetching
  },
  template,
  controller
};

export default laborCategoryDropdownComponent;




// WEBPACK FOOTER //
// ./client/common/directives/labor-category-dropdown/labor-category-dropdown.component.js